import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="eyebrow">/ 05 · What clients say</div>
          <h2 className="mt-4 font-display text-4xl md:text-5xl font-black tracking-tighter text-white">
            Teams that ship with us <span className="text-gradient">stay with us.</span>
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.author + i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: i * 0.1 }}
              className="glass rounded-2xl p-7 relative"
              data-testid={`testimonial-${i}`}
            >
              <Quote size={26} className="text-cyan-400/60 absolute top-6 right-6" />
              <blockquote className="text-slate-200 text-[15px] leading-relaxed">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-white/5">
                <div className="font-display text-white font-semibold text-sm">{t.author}</div>
                <div className="text-xs text-slate-500 font-mono-plex mt-0.5 uppercase tracking-wider">
                  {t.org}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
